<mat-form-field class="filter-select" appearance="fill">
  <mat-label>Selected Filters</mat-label>

  <mat-select
    #select
    multiple
    panelClass="filter-select-panel"
    placeholder="Select filters..."
    [value]="selectedIds"
    (selectionChange)="onSelectionChange($event.value)"
    (openedChange)="onPanelToggled($event)">
    <mat-select-trigger>
      <span class="filter-select__trigger">
        @for (filter of selectedFilters; track trackByFilter($index, filter)) {
          <span class="filter-select__trigger-chip">{{ filter.slug }}</span>
        }
      </span>
    </mat-select-trigger>

    <div
      class="filter-select-panel__header"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      (keyup)="$event.stopPropagation()">
      <div class="filter-select-panel__search">
        <mat-icon aria-hidden="true">search</mat-icon>
        <input
          #searchInput
          class="filter-select-panel__search-input"
          type="text"
          placeholder="Filter options (e.g. activity)"
          aria-label="Filter available options"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchTermChange($event)"
          (keydown)="onSearchKeydown($event)" />
        @if (searchTerm) {
          <button
            mat-icon-button
            type="button"
            aria-label="Clear search"
            (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>

      @if (matchingFilters.length > 1) {
        <div class="filter-select-panel__bulk">
          <button
            mat-button
            type="button"
            color="primary"
            [disabled]="allMatchingSelected"
            (click)="selectAllMatching()">
            Select all matching ({{ matchingFilters.length }})
          </button>
          @if (someMatchingSelected) {
            <button mat-button type="button" (click)="deselectAllMatching()">
              Deselect all matching
            </button>
          }
        </div>
      }
    </div>

    <div class="filter-select-panel__options">
      @for (filter of visibleFilters; track trackByFilter($index, filter)) {
        <mat-option [value]="filter.id">{{ filter.slug }}</mat-option>
      }

      @if (!visibleFilters.length) {
        <div class="filter-select-panel__empty">No matching filters</div>
      }
    </div>
  </mat-select>
</mat-form-field>
